<template>
  <div
    :class="{ 'container': useContainer, 'redirect-block-select': blockParams?.isUrl }"
    :style="{
      'background-color': useBackgroundColor,
      'padding-top': paddingTop + 'px',
      'padding-bottom': paddingBottom + 'px'
    }"
    @click="$emit('block:redirect')"
  >
    <h3 v-if="useHeader">
      {{ title }}
    </h3>
    <div class="faq-items">
      <faq-item
        v-for="(block, index) in blocksByTag"
        :key="index"
        :fields="convertBlockFields(block)"
        :is-active="$faq.activeIndexes?.[blockId]?.[index]"
        :is-single="false"
        @click="$faq.toggleActive(blockId, index)"
      />
    </div>
  </div>
</template>

<script>
import FaqItem from '../faq-item/index.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default {
  components: { FaqItem },
  mixins: [staticBlockMixin]
}
</script>
